export enum AdministrativeUnitLevel {
    province = 'province',
    /**
     * @deprecated
     */
    district = 'district',
    commnue = 'commune',
}
